module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill=\"#010101\" d=\"M1.425.35L14.575 8l-13.15 7.65V.35z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/01-play.svg
// module id = 64
// module chunks = 0